import { Show, SimpleShowLayout, useRecordContext } from "react-admin";
import {
  Card,
  CardContent,
  Typography,
  Divider,
  Chip,
  Stack,
  Grid,
  Box,
} from "@mui/material";
import {
  MonetizationOn,
  Public,
  Flag,
  Label,
} from "@mui/icons-material";

const ArrayFieldStyled = ({ label, values, icon }: { label: string; values: string[]; icon?: JSX.Element }) => (
  <Box mb={2}>
    <Typography variant="subtitle2" gutterBottom>
      {icon && <Box component="span" mr={1}>{icon}</Box>}
      {label}
    </Typography>
    <Stack direction="row" flexWrap="wrap" gap={1}>
      {values?.map((val, i) => (
        <Chip key={i} label={val} variant="outlined" color="primary" />
      ))}
    </Stack>
  </Box>
);

const RulesDetails = () => {
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Card sx={{ borderRadius: 3, mt: 2, boxShadow: 3 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom>
          {record.name}
        </Typography>

        <Divider sx={{ mb: 2 }} />

        <Grid container spacing={2}>
          <Grid xs={12} sm={4}>
            <Typography variant="body2" color="text.secondary">Rate</Typography>
            <Typography variant="subtitle1">{record.rate}</Typography>
          </Grid>
          <Grid xs={12} sm={4}>
            <Typography variant="body2" color="text.secondary">Threshold</Typography>
            <Typography variant="subtitle1">{record.threshold}</Typography>
          </Grid>
          <Grid xs={12} sm={4}>
            <Typography variant="body2" color="text.secondary">Currency Code</Typography>
            <Typography variant="subtitle1">
              <MonetizationOn fontSize="small" sx={{ mr: 0.5 }} />
              {record.currencyCode}
            </Typography>
          </Grid>
        </Grid>

        <Divider sx={{ my: 3 }} />

        <ArrayFieldStyled
          label="Countries From"
          values={record.countriesFrom}
          icon={<Public fontSize="small" />}
        />
        <ArrayFieldStyled
          label="Countries To"
          values={record.countriesTo}
          icon={<Public fontSize="small" />}
        />
        <ArrayFieldStyled
          label="States To"
          values={record.statesTo}
          icon={<Flag fontSize="small" />}
        />
        <ArrayFieldStyled
          label="Made In Countries"
          values={record.madeInCountries}
          icon={<Flag fontSize="small" />}
        />
        <ArrayFieldStyled
          label="Sellers Label"
          values={record.sellersLabel}
          icon={<Label fontSize="small" />}
        />
      </CardContent>
    </Card>
  );
};

export const RulesShow = (props: any) => (
  <Show {...props}>
    <SimpleShowLayout>
      <RulesDetails />
    </SimpleShowLayout>
  </Show>
);

export default RulesShow;
